import React, { Component } from 'react';
import '../Modal.css';
import './ModalHowTo.css';

import leftMove from '../../../shared/assets/modals/left-move.svg';
import rightMove from '../../../shared/assets/modals/right-move.svg';

import howTo1SVG from '../../../shared/assets/modals/howTo1.svg';
import howTo2SVG from '../../../shared/assets/modals/howTo2.svg';
import howTo3SVG from '../../../shared/assets/modals/howTo3.svg';
import howTo4SVG from '../../../shared/assets/modals/howTo4.svg';


class ModalHowTo extends Component {
  state = {
    showLeft: false,
    showRight: true,
    page: 1
  }

  nextPage = () => {
    if (this.state.page < 4) {
      let showLeft = this.state.showLeft;
      let showRight = this.state.showRight;
      if (this.state.page === 1) showLeft = true;
      if (this.state.page === 3) showRight = false;

      this.setState({
        ...this.state,
        page: this.state.page + 1,
        showLeft: showLeft,
        showRight: showRight
      });
    }
  }

  prevPage = () => {
    if (this.state.page > 1) {
      let showLeft = this.state.showLeft;
      let showRight = this.state.showRight;
      if (this.state.page === 4) {
        showLeft = true;
        showRight = true;
      }
      if (this.state.page === 2) showLeft = false;

      this.setState({
        ...this.state,
        page: this.state.page - 1,
        showLeft: showLeft,
        showRight: showRight
      });
    }
  }

  info = {
    1: {
      text: "Click to select a frame to swap.",
      img: howTo1SVG
    },
    2: {
      text: "The selected frame can only be swapped with gray frames.",
      img: howTo2SVG
    },
    3: {
      text: "Press the play button to preview the final animation.",
      img: howTo3SVG
    },
    4: {
      text: "The animation begins at the top of the reel.",
      img: howTo4SVG
    }
  }

  render() {
    return (
      <div>
        <div className='backdrop'/>
        <div className='modal carousel-container'>
          <div className='move-container'>
            {this.state.showLeft && <img className='left-move float-left' src={leftMove} alt='prev' onClick={this.prevPage} />}
            {this.state.showRight && <img className='right-move float-right' src={rightMove} alt='next' onClick={this.nextPage} />}
          </div>

          <h1 className='small-bottom modal-item modal-title '>How to play</h1>
          <img className='modal-item image' src={this.info[this.state.page].img} alt='pic' />
          <div className='modal-item carousel-text'>
            <p>{this.info[this.state.page].text}</p>
          </div>
          <div className='modal-item button-container'>
            {this.state.page===4 && <button className='modal-button' style={{ fontFamily: 'NYTFranklin' }} onClick={this.props.onPlay}>Play</button>}
          </div>
          <div className='modal-item dot-container'>
            <div className={this.state.page===1 ? 'dot dot-selected' : 'dot'} />
            <div className={this.state.page===2 ? 'dot dot-selected' : 'dot'} />
            <div className={this.state.page===3 ? 'dot dot-selected' : 'dot'} />
            <div className={this.state.page===4 ? 'dot dot-selected' : 'dot'} />
          </div>
        </div>
      </div>
    )
  }
}

export default ModalHowTo;